"use client";

import { useMixpanel } from "@/hooks/mixpanel/use-mixpanel";

export const useLocalFileTracking = () => {
  const { track } = useMixpanel();

  const trackLocalFile = (filename: string) => {
    track("Local File Tracking", {
      file_name: filename,
    });
  };

  return {
    trackLocalFile,
  };
};
